import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {IFooterPopularArticlesResponse, IFooterPopularSectionsResponse, IFooterSubscribeResponse} from '../types';
import {transformErrorResponse} from 'core/redux/store/api/utils';
import {IEmailSubsribe} from '../models';

export const FOOTER_POPULAR_ARTICLES_PATH = '/footer/popular-articles';
export const FOOTER_POPULAR_SECTIONS_PATH = '/footer/popular-sections';

/* eslint-disable sort-keys */
export const footerApiServices = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getPopularArticles: builder.query<IFooterPopularArticlesResponse, void>({
            query: () => `${API_VERSION}${FOOTER_POPULAR_ARTICLES_PATH}`,
            transformResponse: (response: {data: IFooterPopularArticlesResponse}) => response?.data ?? null,
            transformErrorResponse,
            keepUnusedDataFor: 86400,
        }),
        getPopularSections: builder.query<IFooterPopularSectionsResponse, void>({
            query: () => `${API_VERSION}${FOOTER_POPULAR_SECTIONS_PATH}`,
            transformResponse: (response: {data: IFooterPopularSectionsResponse}) => response?.data ?? null,
            transformErrorResponse,
            keepUnusedDataFor: 86400,
        }),
        subscribeEmail: builder.mutation({
            query: (body: IEmailSubsribe) => ({
                url: `${API_VERSION}/subscribe`,
                method: 'POST',
                body: {
                    agreement: body.agreement,
                    ['form-name']: body.formName,
                    email: body.email,
                },
            }),
            transformErrorResponse,
            transformResponse: (response: {data: IFooterSubscribeResponse}) => response?.data,
        }),
    }),
});

export const {
    useGetPopularArticlesQuery: useGetFooterPopularArticlesQuery,
    useGetPopularSectionsQuery: useGetFooterPopularSectionsQuery,
    useSubscribeEmailMutation: useFooterSubscribeEmailMutation,
    util: {getRunningQueriesThunk: getFooterRunningQueriesThunk},
} = footerApiServices;

export const {getPopularArticles, getPopularSections} = footerApiServices.endpoints;
